import React from "react";
import {
  SiReact,
  SiAndroid,
  SiApple,
  SiFlutter,
  SiAmazon,
} from "react-icons/si";

const techIcons: {
  icon: any;
  label: string;
}[] = [
  { icon: SiReact, label: "React Native" },
  { icon: SiAndroid, label: "Android" },
  { icon: SiApple, label: "iOS" },
  { icon: SiFlutter, label: "Flutter" },
  { icon: SiAmazon, label: "AWS" },
];

export default function PortfolioFooter() {
  return (
    <footer
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        marginTop: "3rem",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          animation: "scroll 30s linear infinite",
        }}
      >
        {[...techIcons, ...techIcons, ...techIcons, ...techIcons].map(
          ({ icon: Icon, label }, index) => (
            <span
              key={`${label}-${index}`}
              aria-label={label}
              title={label}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.75rem",
                marginRight: "3rem",
              }}
            >
              <Icon size={48} color="#d1d5db" />
              <span
                style={{
                  fontWeight: "bold",
                  color: "#9ca3af",
                  fontSize: "1rem",
                }}
              >
                {label}
              </span>
            </span>
          )
        )}
      </div>

      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          footer div {
            will-change: transform;
          }
        `}
      </style>
    </footer>
  );
}
